/**
 * @method binarySearch
 * items: sorted array (assumes has a field called index which provides the index location of the item in the array)
 */
const binarySearch = (
  items,
  targetValue,
  options = {
    isBeforeTarget: (middleItemValue, value) => middleItemValue < value,
    isAfterTarget: (middleItemValue, value) => value < middleItemValue,
  },
) => {
  let left = items.find((x) => x !== undefined).index; // first element may not be at position 0
  let right = items.length - 1;
  const { isBeforeTarget, isAfterTarget } = options;

  while (left <= right) {
    const middle = (right + left) >> 1;
    if (isBeforeTarget(items[middle], targetValue)) {
      left = middle + 1;
    } else if (isAfterTarget(items[middle], targetValue)) {
      right = middle - 1;
    } else {
      return items[middle];
    }
  }

  return null;
};

export default binarySearch;
